import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Download from '@hellodarwin/icons/dist/icons/Download';
import Tooltip from 'antd/es/tooltip';
import { useTheme } from 'styled-components';
import FileBoxContent from './file-box-content';
import { DownloadIconContainer, FileBoxContainer } from './styles';
const FileBox = ({ assetId, displayName, extension, createdAt, fileSize, Icon, handleDownload, }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    const handleDownloadFile = () => {
        handleDownload(assetId);
    };
    return (_jsxs(FileBoxContainer, { children: [_jsx(FileBoxContent, { displayName: displayName, extension: extension, createdAt: createdAt, fileSize: fileSize, Icon: Icon }), _jsx(Tooltip, { title: t('gin_steps|download_asset'), children: _jsx(DownloadIconContainer, { onClick: handleDownloadFile, children: _jsx(Download, { size: 16, color: theme.colors.grey_1 }) }) })] }));
};
export default FileBox;
